import * as React from 'react';
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import { alpha } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppNavbar from './dashboard/components/AppNavbar';
import Header from './dashboard/components/Header';
import MainGrid from './dashboard/components/MainGrid';
import MainGridv2 from './dashboard/components/MainGridv2';

import SideMenu from './dashboard/components/SideMenu';
import AppTheme from './shared-theme/AppTheme';
import EVConfigDashboard from './dashboard/components/configuration/EVConfigDashboard'
import { Provider } from 'react-redux';
import store from './app/store';
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from './dashboard/theme/customizations';
// import VehicleDashboard from './dashboard/vehicledashboard/VehicleDashboard';
import VehicleDashboard from './dashboard/components/VehicleDashboardNew';
import Analytics from './dashboard/components/Analytics';

import ChargerDashboard from './dashboard/chargerdashboard/ChargerDashboard';

// import VDashboard from "./features/vehicleDashboard/VDashboard"

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

const Layout = () => {
  return <Box sx={{ display: 'flex' }}>
    <SideMenu />
    <AppNavbar />
    {/* Main content */}
    <Box
      component="main"
      sx={(theme) => ({
        flexGrow: 1,
        backgroundColor: theme.vars
          ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
          : alpha(theme.palette.background.default, 1),
        overflow: 'auto',
      })}
    >
      <Stack
        spacing={2}
        sx={{
          alignItems: 'center',
          mx: 3,
          pb: 5,
          mt: { xs: 8, md: 0 },
        }}
      >
        <Header />
        <Outlet />
      </Stack>
    </Box>
  </Box>
}

const router = createBrowserRouter([
  {    
    path: "/",
    element: <Layout />, 
    children: [
      {
        path: "/",
        element: <MainGrid />,
      },
      {
        path: "/analytics",
        element: <Analytics />,
      },
      {
        path: "/v2",
        element: <MainGridv2 />,
      },
      {
        path: "/config",
        element: <EVConfigDashboard />,
      },      
      {
        path: "/vehicle-dashboard",
        element: <VehicleDashboard />,
      },
      {
        path: "/charger-dashboard",
        element: <ChargerDashboard />,
      },      
    ]
  },
],{basename: '/dashboard'});

export default function Dashboard(props) {
  return (

    <AppTheme {...props} themeComponents={xThemeComponents}>
      <Provider store={store}>
        <RouterProvider router={router} >
          <CssBaseline enableColorScheme />
        </ RouterProvider>
      </Provider>
    </AppTheme>

  );
}
